"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MIGRATION_JOBS_STORE_KEY () {
        return MIGRATION_JOBS_STORE_KEY;
    },
    get getMigrationJobsState () {
        return getMigrationJobsState;
    },
    get setMigrationJobsStallInterval () {
        return setMigrationJobsStallInterval;
    },
    get updateMigrationJobsState () {
        return updateMigrationJobsState;
    }
});
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _globals = require("~/utils/globals");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const MIGRATION_JOBS_STORE_KEY = 'NC_MIGRATION_JOBS';
const initState = {
    version: '0',
    stall_check: Date.now(),
    locked: false
};
const getMigrationJobsState = async ()=>{
    const ncMeta = _Noco.default.ncMeta;
    const qb = await ncMeta.metaGet(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.STORE, {
        key: MIGRATION_JOBS_STORE_KEY
    });
    if (!qb) {
        await ncMeta.metaInsert2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.STORE, {
            key: MIGRATION_JOBS_STORE_KEY,
            value: JSON.stringify(initState)
        }, true);
        return initState;
    }
    try {
        const migrationJobsState = JSON.parse((qb == null ? void 0 : qb.value) || '{}');
        if ('version' in migrationJobsState) {
            return migrationJobsState;
        }
        return initState;
    } catch (e) {
        console.error('Error parsing migration jobs state', e);
        return initState;
    }
};
const updateMigrationJobsState = async (state, oldState)=>{
    const ncMeta = _Noco.default.ncMeta;
    const migrationJobsState = oldState || await getMigrationJobsState();
    if (!migrationJobsState) {
        const updatedState = _extends({}, initState, state);
        await ncMeta.metaInsert2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.STORE, {
            key: MIGRATION_JOBS_STORE_KEY,
            value: JSON.stringify(updatedState)
        }, true);
    } else {
        const updatedState = _extends({}, migrationJobsState, state);
        await ncMeta.metaUpdate(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.STORE, {
            value: JSON.stringify(updatedState)
        }, {
            key: MIGRATION_JOBS_STORE_KEY
        });
    }
};
const setMigrationJobsStallInterval = ()=>{
    // update stall check every 5 mins
    const interval = setInterval(async ()=>{
        try {
            const migrationJobsState = await getMigrationJobsState();
            migrationJobsState.stall_check = Date.now();
            await updateMigrationJobsState(migrationJobsState);
        } catch (e) {
            console.error('Error updating stall check for migration job', e);
        }
    }, 5 * 60 * 1000).unref();
    return interval;
};
